var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0657 13.2544C11.2309 13.3303 11.4171 13.3476 11.5934 13.3035C11.7698 13.2595 11.926 13.1566 12.0361 13.012L12.3201 12.64C12.4691 12.4413 12.6624 12.28 12.8846 12.1689C13.1067 12.0578 13.3517 12 13.6001 12H16.0001C16.4244 12 16.8314 12.1685 17.1315 12.4686C17.4315 12.7687 17.6001 13.1756 17.6001 13.6V16C17.6001 16.4243 17.4315 16.8313 17.1315 17.1313C16.8314 17.4314 16.4244 17.6 16.0001 17.6C12.181 17.6 8.51828 16.0828 5.81776 13.3823C3.11724 10.6818 1.6001 7.01909 1.6001 3.19998C1.6001 2.77563 1.76867 2.36866 2.06873 2.0686C2.36878 1.76855 2.77575 1.59998 3.2001 1.59998H5.6001C6.02444 1.59998 6.43141 1.76855 6.73147 2.0686C7.03153 2.36866 7.2001 2.77563 7.2001 3.19998V5.59998C7.2001 5.84837 7.14227 6.09335 7.03118 6.31552C6.9201 6.53769 6.75881 6.73094 6.5601 6.87998L6.1857 7.16078C6.03883 7.27292 5.93531 7.43244 5.89273 7.61226C5.85015 7.79207 5.87112 7.98108 5.9521 8.14717C7.04544 10.3679 8.84364 12.1638 11.0657 13.2544Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconWhite);
export default __webpack_public_path__ + "static/media/phoneIconWhite.73f022491daaa4b27faa545ab5840612.svg";
export { ForwardRef as ReactComponent };